// extracted by mini-css-extract-plugin
export default {"slot":"mobile-preview-toggle_slot__5cVEy","toggle":"mobile-preview-toggle_toggle__SUqI-"};